.links { display: flex; flex-wrap: wrap; gap: 8px 20px; }
.link { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); text-decoration: underline; }
@media (max-width: 639px) {
  .link { display: inline-flex; align-items: center; min-height: 44px; }
}
